import React from "react";
import { StandardButtonStyle } from "./StandardButton.style";

interface StandardButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  textButton: string;
}

const StandardButton: React.FC<StandardButtonProps> = (props) => {
  const { textButton, ...newProps } = props;
  return <StandardButtonStyle {...(newProps as any)}>{props.textButton}</StandardButtonStyle>;
};

export default StandardButton;
